'use strict';

var emofaBackendApp = angular.module('emofa.backed', [
  'gettext',
  'ngMessages',
  'ngSanitize',
  'ngResource',
  'ngRoute',
  'ngStorage',
  'ui.router',
  'ui.grid',
  'lbServices',
  'angularModalService',
  'ui-notification'
]);

emofaBackendApp.config(function ($httpProvider,
                                 $stateProvider,
                                 $resourceProvider,
                                 $urlRouterProvider,
                                 LoopBackResourceProvider,
                                 NotificationProvider) {

  $resourceProvider.defaults.stripTrailingSlashes = false;
  $httpProvider.defaults.withCredentials = true;
  $urlRouterProvider.otherwise('/login');

  LoopBackResourceProvider.setAuthHeader('X-Access-Token');
  LoopBackResourceProvider.setUrlBase('https://order.emofa.ch/api');

  $stateProvider
    .state('login', {
      url: '/login',
      templateUrl: 'https://order.emofa.ch/app/modules/login/LoginView.html',
      controller: 'LoginCtrl as LoginCtrl'
    })
    .state('password-forgotten', {
      url: '/password-forgotten',
      templateUrl: 'https://order.emofa.ch/app/modules/login/PasswordForgottenView.html',
      controller: 'PasswordForgottenCtrl as PasswordForgottenCtrl'
    })
    .state('password-reset', {
      url: '/password-reset/:token',
      templateUrl: 'https://order.emofa.ch/app/modules/login/PasswordResetView.html',
      controller: 'PasswordResetCtrl as PasswordResetCtrl'
    })
    .state('app', {
      url: '/app',
      templateUrl: 'https://order.emofa.ch/app/modules/main/MainView.html',
      abstract: true,
      controller: 'MainCtrl as MainCtrl',
      resolve: {
        role: function ($sessionStorage) {
          return $sessionStorage.userRole;
        }
      }
    })
    .state('app.start', {
      url: '/start',
      templateUrl: 'https://order.emofa.ch/app/modules/start/StartView.html',
      controller: 'StartCtrl as StartCtrl'
    })
    .state('app.user', {
      url: '/user',
      templateUrl: 'https://order.emofa.ch/app/modules/user/UserView.html',
      controller: 'UserCtrl as UserCtrl',
      resolve: {
        user: function (AppUser) {
          return AppUser.find({
            where: {
              location: {
                near: {
                  lat: 42.266271,
                  lng: -72.6700016
                },
                maxDistance: 2
              }
            }
          }).$promise;
        }
      }
    })
    .state('app.feedback', {
      url: '/feedback',
      templateUrl: 'https://order.emofa.ch/app/modules/comment/CommentView.html',
      controller: 'CommentCtrl as CommentCtrl'
    })
    .state('app.orderlist', {
      url: '/order/:type',
      templateUrl: 'https://order.emofa.ch/app/modules/order/OrderListView.html',
      controller: 'OrderListCtrl as OrderListCtrl',
      resolve: {
        items: function ($sessionStorage, Item) {
          if($sessionStorage.stock && $sessionStorage.stock.length) {
            return $sessionStorage.stock;
          } else {
            return Item
              .list()
              .$promise
              .then((response) => {
                $sessionStorage.stock = response.data;
                return response.data;
              });
          }
        }
      }
    })
    .state('app.shipment', {
      url: '/shipment',
      templateUrl: 'https://order.emofa.ch/app/modules/order/ShipmentView.html',
      controller: 'ShipmentCtrl as ShipmentCtrl'
    })
    .state('app.cart', {
      url: '/cart',
      templateUrl: 'https://order.emofa.ch/app/modules/order/CartView.html',
      controller: 'CartCtrl as CartCtrl',
      resolve: {
        items: function ($sessionStorage) {
          return $sessionStorage.items;
        }
      }
    })
    .state('app.settings', {
      url: '/settings',
      templateUrl: 'https://order.emofa.ch/app/modules/settings/SettingsView.html',
      controller: 'SettingsCtrl as SettingsCtrl',
      resolve: {
        user: function (AppUser) {
          return AppUser.getCurrent().$promise;
        }
      }
    })
    .state('app.logout', {
      url: '/logout',
      controller: function ($state, AppUser) {
        AppUser.logout(
          {},
          {},
          function () {
            $state.go('login');
          },
          function (error) {
            console.error(error);
          });
      }
    });


  $httpProvider.interceptors.push(function ($q, $location, LoopBackAuth) {
    return {
      responseError: function (rejection) {
        if (rejection.status === 401) {
          LoopBackAuth.clearUser();
          LoopBackAuth.clearStorage();
          $location.nextAfterLogin = $location.path();
          $location.path('/login');
        }
        return $q.reject(rejection);
      }
    };
  });

  NotificationProvider.setOptions({
    delay: 4000,
    startTop: 20,
    startRight: 10,
    verticalSpacing: 20,
    horizontalSpacing: 20,
    positionX: 'center',
    positionY: 'bottom'
  });

});

emofaBackendApp.run(function ($rootScope,
                              $transitions,
                              gettextCatalog) {
  var lang = 'de';
  var userLang = (navigator.language || navigator.userLanguage || 'de').toLowerCase();

  $transitions.onSuccess({}, function (transition) {
    var toState = transition.to().name;
    $rootScope.currentState = toState;
  });

  if (userLang.indexOf('de') > -1) {
    lang = 'de';
  } else if (userLang.indexOf('it') > -1) {
    lang = 'it';
  } else if (userLang.indexOf('fr') > -1) {
    lang = 'fr';
  }

  gettextCatalog.loadRemote('/i18n/' + lang + '.json');
  gettextCatalog.setCurrentLanguage(lang);
});

emofaBackendApp.controller('LoginCtrl', require('./modules/login/LoginCtrl'));
emofaBackendApp.controller('PasswordResetCtrl', require('./modules/login/PasswordResetCtrl'));
emofaBackendApp.controller('PasswordForgottenCtrl', require('./modules/login/PasswordForgottenCtrl'));
emofaBackendApp.controller('StartCtrl', require('./modules/start/StartCtrl'));
emofaBackendApp.controller('MainCtrl', require('./modules/main/MainCtrl'));
emofaBackendApp.controller('UserCtrl', require('./modules/user/UserCtrl'));
emofaBackendApp.controller('OrderListCtrl', require('./modules/order/OrderListCtrl'));
emofaBackendApp.controller('CommentCtrl', require('./modules/comment/CommentCtrl'));
emofaBackendApp.controller('CartCtrl', require('./modules/order/CartCtrl'));
emofaBackendApp.controller('SettingsCtrl', require('./modules/settings/SettingsCtrl'));
emofaBackendApp.controller('YesNoController', require('./modules/order/YesNoCtrl.js'));
emofaBackendApp.controller('ShipmentCtrl', require('./modules/order/ShipmentCtrl.js'));

emofaBackendApp.value('settings', require('./config'));




// WEBPACK FOOTER //
// ./client/src/app/app.js